module.exports = {"pathContext":{"name":"CensusUpdateTarget","kind":"INTERFACE","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":[{"kind":"OBJECT","name":"CensusAssignment","ofType":null},{"kind":"OBJECT","name":"CensusKennel","ofType":null},{"kind":"OBJECT","name":"CensusWard","ofType":null}]}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/interface-census-update-target.json
// module id = 1604
// module chunks = 154337994155633